import React, { useEffect } from 'react';
import { HypoList } from '../components/Dashboard/HypoList';
import { CalendarMonth } from '../components/Calendar/CalendarMonth';
import { SyncSettings } from '../components/Dashboard/SyncSettings';
import { useAuthStore } from '../store/authStore';
import { useNavigate } from 'react-router-dom';

export const DashboardPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<'hypos' | 'calendar' | 'settings'>('hypos');
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              Dexcom Hypo Tracker
            </h1>
            <p className="text-gray-600 mt-1">
              Bienvenue, {user?.first_name} {user?.last_name}
            </p>
          </div>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Déconnexion
          </button>
        </div>
      </header>

      {/* Tabs */}
      <div className="bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 flex space-x-8">
          <button
            onClick={() => setActiveTab('hypos')}
            className={`py-4 px-2 font-medium border-b-2 transition ${
              activeTab === 'hypos'
                ? 'border-indigo-600 text-indigo-600'
                : 'border-transparent text-gray-600 hover:text-gray-800'
            }`}
          >
            Hypoglycémies
          </button>
          <button
            onClick={() => setActiveTab('calendar')}
            className={`py-4 px-2 font-medium border-b-2 transition ${
              activeTab === 'calendar'
                ? 'border-indigo-600 text-indigo-600'
                : 'border-transparent text-gray-600 hover:text-gray-800'
            }`}
          >
            Calendrier
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`py-4 px-2 font-medium border-b-2 transition ${
              activeTab === 'settings'
                ? 'border-indigo-600 text-indigo-600'
                : 'border-transparent text-gray-600 hover:text-gray-800'
            }`}
          >
            ⚙️ Paramètres
          </button>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-6xl mx-auto px-4 py-8">
        {activeTab === 'hypos' && <HypoList />}
        {activeTab === 'calendar' && <CalendarMonth days={30} />}
        {activeTab === 'settings' && <SyncSettings />}
      </main>
    </div>
  );
};
